'use strict';

var $ = require('jquery');

var config = require('../utils/config.js');

function init() {

    const isArticlePage = config && config.data && config.data.page && config.data.page.templateName === 'Bauer.Golf.Article';

    if (!isArticlePage) {
        return;
    }

    const $widgets = $.findByBem('preferred-sources-google');

    $widgets.each((_, element) => {
        $(element).addBemClass('preferred-sources-google', null, 'centered-compact');

        const isMobileRendering = $(element).parentsByBem('hide-for-large-up').length > 0;
        const $link = $(element).findByBem('preferred-sources-google', 'link');
        const $tooltip = $(element).findByBem('tooltip-container', 'tooltip');

        if (isMobileRendering) {
            if ($tooltip.length > 0) {
                $tooltip.remove();
            }

            if ($link.length > 0) {
                $link.removeAttr('aria-describedby');
            }

            return;
        }

        if ($tooltip.length > 0) {
            $tooltip.addBemClass('tooltip-container', 'tooltip', 'centered-compact');
        }
    });
}

module.exports = {
	init: init
};